const $contentList = $('.list__content');
const $buttonList = $('.list__button');

$buttonList.on('click', $contentList, (e) => {
	const $block = $(e.currentTarget).closest('.list__content');
	const $text = $block.find('.list__text');
	const $button = $block.find('.list__button');

	$text.addClass('is-show');
	$button.fadeOut('300');
});

function init() {
	const $textList = $('.list__text');

	$textList.each((index, value) => {
		let height = $(value).height();

		if (height < 143) {
			$(value).parent().find($buttonList).css('display', 'none');
		}
	});
}

export default {
	init,
};
